<template>
  <div>
    <div class="div-title uppercase flex justify-between pb-3.5 border-b border-b-gray-400 mb-10 px-4">
      <h1 class="text-4xl">
        CAREERS
      </h1>
      <div>
        <NuxtLink :to="'/employment'" class="uppercase text-[22px]"><span>back to results</span></NuxtLink>
      </div>
    </div>
    <div class="flex border-black border px-2 py-3 md:p-6 flex-wrap" v-if="ready">
      <div class="flex justify-between w-full mb-10 flex-wrap">
        <div class="w-full md:basis-2/4 mb-4 md:mb-0">
          <div class="flex font-bold">
            <p class="min-w-[100px]">Posted:</p>
            <p>{{ career.posted }}</p>
          </div>
          <div class="flex">
            <p class="font-bold min-w-[100px]" >Term:</p>
            <p>{{ career.term }}</p>
          </div>
        </div>
        <div class="w-full md:basis-2/4 flex justify-center md:justify-end">
          <div class="flex mr-4">
            <img src="/print.png" alt="Print" width="46" height="46">
            <button class="flex items-center ml-2" @click="print()">Print this Page</button>
          </div>
          <div>
            <div class="flex">
              <span class="flex items-center mr-2">Share</span>
              <div class="cursor-pointer" v-on:click="shareOn('twitter')">

                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="46" height="46" x="0" y="0"
                     viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"
                     class="fill-white mr-2 p-2 rounded-full hover:bg-zinc-700 bg-black cursor-pointer"><g>
                  <g xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path
                          d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z"
                          data-original="#000000" class=""/>
                    </g>
                  </g>
                  </g>
                </svg>
              </div>
              <div class="cursor-pointer" v-on:click="shareOn('facebook')">

                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="46" height="46" x="0" y="0"
                     viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve"
                     class="fill-white p-2 rounded-full hover:bg-zinc-700 bg-black cursor-pointer"><g>
                  <g xmlns="http://www.w3.org/2000/svg">
                    <path id="f_1_" style=""
                          d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"
                          data-original="#010002"/>
                  </g>
                </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="basic-4/4 flex-col flex md:mb-10">
        <div class="basis-4/5 flex flex-col">
          <div class="ql-snow">
            <div class="ql-editor">
              <div v-html="career.overview"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-full" >
        <h3 class="border-b-2 border-black py-2 text-5xl font-title"> Contact</h3>
        <div class="bg-[#FCFCFC] px-2 py-3 md:p-6">
          <div class="flex flex-wrap">
            <div class="w-full md:basis-2/4 flex flex-col">
              <div class="mb-4">
                <p class="font-bold">{{ career.contact_name }}</p>
              </div>
              <div class="flex">
                <p class="font-bold mr-2">Phone:</p>
                <p>{{career.phonenumber}}</p>
              </div>
              <div class="flex">
                <p class="font-bold mr-2">Email:</p>
                <a class="text-darkRed hover:opacity-70 hover:text-darkBlue"
                   :href="'mailto:' + career.email">{{ career.email }}</a>
              </div>
            </div>
            <div class="w-full md:basis-1/4 flex flex-col">
              <div class="mb-4">
                <p class="font-bold">Opportunity Location</p>
              </div>
              <div>
                <p>{{ career.location_name }}</p>
              </div>
              <div class="flex flex-col">
                <p>{{ career.address_1 }}</p>
                <p>{{ career.address_2 }}</p>
                <p>{{ career.address }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="flex flex-row mb-8 flex-wrap" v-if="ready">-->
<!--      <div class="basic-4/4 w-full mb-6 lg:basis-1/4 px-3 lg:mb-0">-->
<!--        <div class="min-h-[55px] bg-darkRed uppercase text-white w-fll p-3.5 text-3xl">offered by</div>-->
<!--        <div class="profile_content p-3.5 bg-gray-100">-->
<!--          <p class="mb-5">{{ career.company }}</p>-->
<!--          <p class="font-bold">Opportunity Location</p>-->
<!--          <p>{{ career.location_name }}</p>-->
<!--          <p>{{ career.address_1 }}</p>-->
<!--          <p>{{ career.address_2 }}</p>-->
<!--          <p class="mb-5">{{ career.address }}</p>-->
<!--          <p class="font-bold">Contact</p>-->
<!--          <p>{{ career.contact_name }}</p>-->
<!--          <p>{{ career.contact_title }}</p>-->
<!--          <a class="text-darkRed hover:opacity-70 hover:text-darkBlue"-->
<!--             :href="'mailto:' + career.email">{{ career.email }}</a>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="basis-4/4 lg:basis-3/4 px-3">-->
<!--        <div class="flex justify-between mb-3 flex-col-reverse sm:flex-row">-->
<!--          <h2 class="uppercase text-[30px] w-full sm:w-fit">description</h2>-->
<!--          <div class="w-full sm:w-fit">-->
<!--            <div class="flex justify-between mb-4 sm:mb-0 sm:justify-center lg:justify-end space-x-4">-->

<!--              <div class="flex mr-4">-->
<!--                <img src="/print.png" alt="Print" width="46" height="46">-->
<!--                <button class="flex items-center ml-2" @click="print()">Print this Page</button>-->
<!--              </div>-->

<!--              <div class="flex">-->
<!--                <span class="flex items-center mr-2">Share</span>-->
<!--                <div class="cursor-pointer" v-on:click="shareOn('twitter')">-->

<!--                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"-->
<!--                         xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="46" height="46" x="0" y="0"-->
<!--                         viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"-->
<!--                         class="fill-white mr-2 p-2 rounded-full hover:bg-zinc-700 bg-black cursor-pointer"><g>-->
<!--                  <g xmlns="http://www.w3.org/2000/svg">-->
<!--                    <g>-->
<!--                      <path-->
<!--                          d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z"-->
<!--                          data-original="#000000" class=""/>-->
<!--                    </g>-->
<!--                  </g>-->
<!--                  </g>-->
<!--                </svg>-->
<!--                </div>-->
<!--                <div class="cursor-pointer" v-on:click="shareOn('facebook')">-->

<!--                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"-->
<!--                         xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="46" height="46" x="0" y="0"-->
<!--                         viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve"-->
<!--                         class="fill-white p-2 rounded-full hover:bg-zinc-700 bg-black cursor-pointer"><g>-->
<!--                  <g xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path id="f_1_" style=""-->
<!--                          d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"-->
<!--                          data-original="#010002"/>-->
<!--                  </g>-->
<!--                </g>-->
<!--                </svg>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="x-2">-->
<!--          <div class="flex flex-row mb-2">-->
<!--            <div class="basis-1/5">-->
<!--              <p class="font-bold">Career</p>-->
<!--            </div>-->
<!--            <div class="basis-4/5 ">-->
<!--              <p>{{ career.title }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-row mb-2">-->
<!--            <div class="basis-1/5">-->
<!--              <p class="font-bold">Type</p>-->
<!--            </div>-->
<!--            <div class="basis-4/5 ">-->
<!--              <p>{{ career.type }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-row mb-6">-->
<!--            <div class="basis-1/5">-->
<!--              <p class="font-bold">Overview</p>-->
<!--            </div>-->
<!--            <div class="basis-4/5 flex flex-col">-->
<!--              <div class="ql-snow">-->
<!--                <div class="ql-editor">-->
<!--                  <div v-html="career.overview"></div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="flex flex-row mb-2">-->
<!--            <div class="basis-1/5">-->
<!--              <p class="font-bold">Posted </p>-->
<!--            </div>-->
<!--            <div class="basis-4/5 ">-->
<!--              <p>{{ career.posted }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-row mb-2">-->
<!--            <div class="basis-1/5">-->
<!--              <p class="font-bold">Term</p>-->
<!--            </div>-->
<!--            <div class="basis-4/5 ">-->
<!--              <p>{{ career.term }}</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="flex flex-row">-->
<!--            <div class="basis-1/5">-->
<!--              <p class="font-bold">Details</p>-->
<!--            </div>-->
<!--            <div class="basis-4/5 ">-->
<!--              <div class="ql-snow">-->
<!--                <div class="ql-editor">-->
<!--                  <div v-html="career.details"></div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div v-else>
      <LoadersSpinner/>
    </div>
  </div>
</template>

<script setup>
import { http } from "~/utils/http";
import {computed, ref} from "vue";
import {useHead, navigateTo, useRoute} from "nuxt/app";
import {useSiteTitle} from "~/composables/state";
import {useSiteWeb} from "~/composables/state";
import {Page} from "~/composables/nhTypes";

const siteWeb = useSiteWeb();
const siteTitle = useSiteTitle();
const route = useRoute();
const career = ref([]);
const ready = ref(false);
const id = route.params.id;
const page = ref(new Page());

useHead({
  title: computed(() => page.value.meta_title + ' - ' + siteTitle.value) ,
  meta: [
    {name: 'description', content: computed(() => page.value.meta_description)},
    {name: 'keywords', content: computed(() => page.value.meta_keywords)},
    { property: 'og:title', content: computed(() => page.value.meta_title + ' - ' + siteTitle.value) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() => page.value.meta_description) },
    { property: 'og:url', content:computed(() =>route.fullPath) },
  ],
})

const print = async () => {
  navigateTo('/employment/print/' + id);
}

const shareOn = (type) => {
  const url = siteWeb.value+'/employment/title/' + id;
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-500,top=-500`;
  if(type === 'facebook'){
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank',params)
  }
  if(type === 'twitter') {
    window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', params)
  }
}


const getData = async () => {
  try {
    await http.get("/api/career/" + id).then(async (response) => {
      career.value = response.data;
      await getPages();
      career.value.type = response.data.career_type ? response.data.career_type.name : '';
      career.value.term = response.data.term ? response.data.term.name : '';
      career.value.company = response.data.company ? response.data.company : '';
      career.value.address_1 = response.data.address_1 ? response.data.address_1 : '';
      career.value.address_2 = response.data.address_1 ? response.data.address_2 : '';
      career.value.state_province = response.data.state_province ? response.data.state_province.name : '';
      career.value.address = response.data.city + ', ' + response.data.state_province + ' ' + response.data.zip;
      career.value.contact_name = response.data.first_name + ' ' + response.data.last_name;
      career.value.phonenumber = response.data.phonenumber;
      career.value.company = response.data.company ? response.data.company.name : '';
      career.value.posted = new Intl.DateTimeFormat('default', {    timeZone: 'utc',
        month: 'long',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(response.data.created_at));
      ready.value = true;
      console.log(career)
    });
  } catch (e) {
  }
};

const getPages = async () => {
  try {
    await http
        .get("/api/pages/get-page", {
          params: {
            permalink: 'employment',
          }
        })
        .then((response) => {
          if (response.data.page != null) {
            page.value.meta_title = career.value.title;
            page.value.meta_description = response.data.page.meta_description;
            page.value.meta_keywords = response.data.page.meta_keywords;
          }
        });
  } catch (e) {
  }
}

await Promise.all([getData()]);
</script>
